export type Faq = {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: '¿Sirve si soy terapeuta en formación o recién graduado?',
    a: 'Sí, está diseñado exactamente para eso. Cada protocolo tiene la imagen anatómica del área tratada con los puntos marcados, el diagnóstico diferencial según la MTC, la técnica específica y las contraindicaciones. No necesitas años de experiencia para usarlo con criterio: el atlas te da la estructura, tu formación pone el diagnóstico. Los dos juntos producen sesiones de alto nivel desde el primer día.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Apenas se confirma el pago recibes un correo con el acceso de descarga. Son archivos PDF de alta calidad: los 3 tomos y los 6 bonos. El acceso llega en unos 5 minutos y el material queda tuyo para siempre, con descargas ilimitadas.',
  },
  {
    q: '¿Necesito imprimir todo el material?',
    a: 'No. Está pensado para consultarlo desde la tablet, la computadora o el celular durante la sesión. Si prefieres el papel, todas las páginas están preparadas para imprimirse en A4 y anillarse, y muchos terapeutas imprimen solo el Tomo II de protocolos.',
  },
  {
    q: '¿En qué se diferencia de un libro de acupuntura tradicional?',
    a: 'Un libro tradicional está hecho para estudiar; el Atlas está hecho para usar mientras el paciente está en la camilla. Cada página resuelve una consulta concreta: dónde está el punto, a qué meridiano pertenece, qué técnica aplicar y qué contraindicaciones tener en cuenta, con la ilustración anatómica al lado.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tienes 7 días desde la compra para revisarlo completo. Si no es lo que esperabas, escribes un correo y te devolvemos el 100%, sin formularios y sin preguntas. La tasa de devoluciones es menor al 1%.',
  },
  {
    q: '¿Puedo compartirlo con otros terapeutas del equipo?',
    a: 'La licencia es de uso personal para un solo terapeuta. Si trabajas en un centro o quieres equipar a tu equipo, escríbenos y te pasamos las condiciones de licencia múltiple con precio especial.',
  },
]
